module.exports = __webpack_public_path__ + "static/jinx_1024w_q50-90623d82e231248bbd47c02787fffd2a.webp";